export default function DexeroJQueryExtensions($: any) {
  // $.log log quickly
  function customLog(text: string) {
    const timeStamp = +new Date();
    const textToLog = `${timeStamp} - ${text}`;

    try {
      window.console.log.call(window.console, textToLog);
    } catch (e) {}
  }

  $.log = function log(text: string) {
    if (window.debug) {
      customLog(text);
    }
  };

  // $.isBlank Check if object is empty
  $.isBlank = function isBlank(obj: any) {
    return (
      obj === undefined || typeof obj === 'undefined' || !obj || obj === null || $.trim(obj) === ''
    );
  };

  // Scroll to element funcction
  $.fn.scrollTo = function scrollTo(
    offset: boolean | number = false,
    focus: boolean = false,
    callbackFn?: IDCA.IGenericFunc
  ) {
    const elm = this;
    const $body = $('body');
    let pos = elm.length > 0 ? elm.offset().top : 0;
    const pageHeaderHeight = Number($('.page-header').height()) || 0;
    const pageHeaderTopHeight = Number($('.page-header-top').height()) || 0;
    const pageHeaderMenuHeight = Number($('.page-header-menu').height()) || 0;

    if ($body.hasClass('page-header-fixed')) {
      pos = pos - pageHeaderHeight < 0 ? 0 : pos - pageHeaderHeight;
    } else if ($body.hasClass('page-header-top-fixed')) {
      pos = pos - pageHeaderTopHeight < 0 ? 0 : pos - pageHeaderTopHeight;
    } else if ($body.hasClass('page-header-menu-fixed')) {
      pos = pos - pageHeaderMenuHeight < 0 ? 0 : pos - pageHeaderMenuHeight;
    }

    pos = pos + (offset || -1 * elm.height());

    $('html,body').animate(
      {
        scrollTop: pos,
      },
      'slow',
      () => {
        if (focus) {
          $(elm).focus();
        }
        if (typeof callbackFn === 'function') {
          callbackFn();
        }
      }
    );
  };

  // Reset value of :input
  $.fn.resetValue = function resetValue() {
    return this.each(function each() {
      // @ts-ignore
      const self = this;
      // @ts-ignore
      const $this = $(this);
      // @ts-ignore
      const node = this.nodeName.toLowerCase();
      const type = $this.attr('type');

      if (node === 'input' && (type === 'text' || type === 'password')) {
        // @ts-ignore
        this.value = '';
      } else if (node === 'input' && (type === 'radio' || type === 'checkbox')) {
        // @ts-ignore
        this.checked = false;
      } else if (node === 'input' && (type === 'button' || type === 'submit' || type === 'reset')) {
        // we really don't care
      } else if (node === 'select') {
        // @ts-ignore
        (this as any).selectedIndex = $this
          .find('option')
          .filter(() => false)
          .index();
      } else if (node === 'textarea') {
        // @ts-ignore
        this.value = '';
        if ($this.attr('convert_this') === 'true') {
          $this.summernote('code', '');
        }
      } else if (Object.hasOwnProperty.call(self, 'defaultValue')) {
        // @ts-ignore
        this.value = '';
      }
    });
  };

  $.fn.hideOption = function hideOption() {
    this.each(function each() {
      // @ts-ignore
      $(this).wrap('<span>').addClass('hide');
    });
  };

  $.fn.showOption = function showOption() {
    this.each(function each() {
      // @ts-ignore
      const opt = $(this).find('option').removeClass('hide');
      // @ts-ignore
      $(this).replaceWith(opt);
    });
  };
}
